import React from 'react';
import PropTypes from 'prop-types';
import { IconChevronLeft } from 'components/Icons';
import Modal from 'components/Modal';

import features from '../lib/common/features';

import { CONFIRM_BUTTON_STATES } from 'constants';

class BackButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      noticeMessage: null,
      processingNoticeMessage: null,
      buttonState: CONFIRM_BUTTON_STATES.CONFIRM
    };

    this.handleBackButton = this.handleBackButton.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.renderNotice = this.renderNotice.bind(this);
  }

  handleBackButton() {
    if (this.props.selectedSeats && this.props.selectedSeats.length === 0) {
      this.handleConfirm();
      this.setState({
        processingNoticeMessage: true
      });
    } else {
      this.setState({
        noticeMessage: true,
        buttonState: CONFIRM_BUTTON_STATES.CONFIRM
      });
    }
  }

  handleCancel() {
    this.setState({
      noticeMessage: null,
      buttonState: CONFIRM_BUTTON_STATES.CONFIRM
    });
  }

  handleConfirm() {
    this.setState({
      buttonState: CONFIRM_BUTTON_STATES.CONFIRMING
    });

    this.props.handleRelease(() => {
      this.setState({
        buttonState: CONFIRM_BUTTON_STATES.CONFIRM
      });
    });
  }

  renderNotice() {
    if (this.state.noticeMessage) {
      return (
        <Modal>
          <div className="syos-enhanced-notice syos-enhanced-notice--no-close">
            <div className="syos-enhanced-notice__inner">
              <div className="syos-enhanced-notice__message syos-enhanced-notice__message--centered">
                <p>
                  <b>Are you sure you want to change your seating section?</b>
                </p>
                <p>Please note, you will lose your current seats.</p>
              </div>
              <div className="syos-enhanced-notice__actions">
                <button
                  className="syos-button syos-button__cancel"
                  onClick={this.handleCancel}
                  tabIndex={2}
                >
                  {features.getOption('backButton', 'labels').cancel}
                </button>
                <button
                  className="syos-button"
                  disabled={
                    this.state.buttonState === CONFIRM_BUTTON_STATES.CONFIRMING
                  }
                  onClick={this.handleConfirm}
                  tabIndex={3}
                >
                  {this.state.buttonState === CONFIRM_BUTTON_STATES.CONFIRM
                    ? `${features.getOption('backButton', 'labels').confirm}`
                    : `${
                        features.getOption('backButton', 'labels').confirming
                      }`}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      );
    } else {
      return null;
    }
  }

  renderProcessingNotice() {
    if (this.state.processingNoticeMessage) {
      return (
        <Modal>
          <div className="syos-enhanced-notice syos-enhanced-notice--no-close">
            <div className="syos-enhanced-notice__inner">
              <div className="syos-enhanced-notice__message syos-enhanced-notice__message--centered">
                <p>Please wait, we are processing your action.</p>
              </div>
            </div>
          </div>
        </Modal>
      );
    } else {
      return null;
    }
  }

  render() {
    return (
      <div className="syos-back-button">
        <button
          tabIndex={2}
          className="syos-button syos-button--back"
          onClick={() => {
            this.handleBackButton();
          }}
        >
          <IconChevronLeft />{' '}
          {features.getOption('backButton', 'labels').initial}
        </button>
        {this.renderNotice()}
        {this.renderProcessingNotice()}
      </div>
    );
  }
}

BackButton.propTypes = {
  currentPerformanceId: PropTypes.number,
  currentPackageId: PropTypes.number,
  updateContext: PropTypes.func,
  handleRelease: PropTypes.func,
  selectedSeats: PropTypes.array
};

export default BackButton;



// WEBPACK FOOTER //
// ./src/javascripts/components/BackButton.js